import { render, staticRenderFns } from "./profileCard.vue?vue&type=template&id=065db2bc&scoped=true"
import script from "./profileCard.vue?vue&type=script&lang=js"
export * from "./profileCard.vue?vue&type=script&lang=js"
import style0 from "./profileCard.vue?vue&type=style&index=0&id=065db2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065db2bc",
  null
  
)

export default component.exports